import Renewal from '../containers/Renewal'
import RenewLife from '../containers/RenewLife'
import RenewalHistory from '../containers/RenewalHistory'
import QuickRenew from '../containers/QuickRenew'

export default {
  path: 'renewal',
  name: 'Renewal',
  component: Renewal,
  meta: { label: 'osm.renewal.header' },
  redirect: '/osm/renewal/history',
  children: [{
      path: 'renewLife',
      name: 'Renew Life Policy',
      meta: { label: 'osm.renewal.renewLife.header' },
      props: true,
      component: RenewLife
    },
    {
      path: 'history',
      name: 'Renewal History',
      props: true,
      meta: { label: 'osm.renewal.history' },
      component: RenewalHistory
    },
    {
      path: 'renew',
      name: 'Quick Renew',
      props: true,
      meta: { label: 'osm.renewal.quickRenew' },
      component: QuickRenew
    },

  ]
}



// WEBPACK FOOTER //
// ./src/Osm/Renewal/route/index.js